




















export default {
  name: 'DashboardBlockEmptyState',
  props: {
    messageData: {
      type: Object,
      default: () => {
        return {
          title: 'Can’t find any data…',
          desc: 'Data for this dashboard seems to be missing.',
        };
      },
    },
  },
};
